import { CreditPeriodEnum } from 'graph/globalTypes'

export type LimitedApplicationVariant =
  | '1 Application per Week'
  | '5 Applications per Week'
  | '1 Application per Day'

export type LimitedApplicationConfig = {
  credits: number
  period: CreditPeriodEnum
}

export const getLimitedApplicationsConfig = (variant: string): LimitedApplicationConfig => {
  switch (variant) {
    case '1 Application per Day':
      return { credits: 1, period: CreditPeriodEnum.day }
    case '5 Applications per Week':
      return { credits: 5, period: CreditPeriodEnum.week }
    case '1 Application per Week':
    default:
      return { credits: 1, period: CreditPeriodEnum.week }
  }
}
